import {Observable} from 'rxjs/Observable';
import 'rxjs/observable/fromPromise';
import 'rxjs/observable/merge';
import 'rxjs/observable/of';
import 'rxjs/observable/timer';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/scan';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import {createEventHandler, mapPropsStream} from 'recompose';
import {buildInjector} from '../../../_libs/angular-utils';
import {ButtonState} from '../../../core-utilities/enums/ButtonState';
import {FileFulfillmentItemView} from './FileFulfillmentItemView';


// Use legacy service to locally handle per-item requests, since they are allowed to occur in parallel
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'FileAssetDomain',
]);

const StreamedComponent = (props$) => {
  const {
    handler: onSelectApproved,
    stream: selectApproved$,
  } = createEventHandler();
  const {
    handler: onSelectRejected,
    stream: selectRejected$,
  } = createEventHandler();

  const buttonModes$ = Observable
    .merge(
      selectApproved$.map(mapToStatus('approved')),
      selectRejected$.map(mapToStatus('rejected')),
    )
    .withLatestFrom(props$)
    // taskUntil comes before sending the request so that we do not cancel requests in flight
    .takeUntil(props$.last())
    // mergeMap is used so that we do not cancel requests in flight
    // although, this shouldn't be a problem anyway, since we disable to the other button once you confirm one of them
    .mergeMap(([data, props]) => {
      const {e, status} = data;
      e.stopPropagation();
      const mode = status === 'approved' ? 'approveMode' : 'rejectMode';

      return Observable
        .merge(
          Observable.of({[mode]: ButtonState.WORKING}),
          Observable.fromPromise(dependencies.FileAssetDomain.updateStatus(props.model.currentFileAsset, status))
            .switchMap(() => revertAfterTimeout(mode, ButtonState.SUCCESS))
            .catch(() => revertAfterTimeout(mode, ButtonState.ERROR)),
        );
    })
    .startWith({
      approveMode: ButtonState.START,
      rejectMode: ButtonState.START,
    })
    .scan((acc, curr) => ({
      ...acc,
      ...curr,
    }));

  return props$
    .combineLatest(
      buttonModes$,
      (props, buttonModes) => ({
        ...props,
        ...buttonModes,
        onSelectRejected,
        onSelectApproved,
      }));
};

export const FileFulfillmentItemContainer = mapPropsStream(StreamedComponent)(FileFulfillmentItemView);

FileFulfillmentItemContainer.messages = FileFulfillmentItemView.messages;
FileFulfillmentItemContainer.messageProps = FileFulfillmentItemView.messageProps;

function mapToStatus(status) {
  return e => ({e, status});
}

function revertAfterTimeout(mode, resultMode) {
  return Observable
    .merge(
      Observable.of({[mode]: resultMode}),
      Observable.timer(750).mapTo({[mode]: ButtonState.START}),
    );
}



// WEBPACK FOOTER //
// ./src/js/requirements/components/FileFulfillmentItem/FileFulfillmentItemContainer.js